import HttpClient from "../../../core/api/httpClient";
import { PagedList } from "../../../core/api/pagedList";
import { QualityCheckDetailDto, QualityCheckDto } from "../model/qualityCheckDtos";

const baseUrl = '/api/quality-checks';
const getUrl = (searchParams: string): string => (`${baseUrl}?${searchParams}`);

export default class QualityCheckApi {
    static async getQualityCheck(id: string): Promise<QualityCheckDetailDto> {
        const response = await HttpClient.get(`${baseUrl}/${id}`);
        return await response.json();
    }

    static async getQualityChecks(odataQueryParameters?: string):Promise<PagedList<QualityCheckDto>> {
        const response = await HttpClient.get(getUrl(odataQueryParameters ?? ''));
        return await response.json();
    }
}
